<template>
  <Dialog
      id="blog-creation-modal"
      v-model:visible="visible"
      :header="t('CREATE_BLOG')"
      modal
      class="blog-creation-modal"
      :draggable="false"
      :dismissable-mask="true"
  >
    <div class="row">
      <div class="col">
        <add-blog-form
            ref="blogFormRef"
            :disabled-langs="getAvailableLanguages"
            @submit-blog="createBlog"
        />
      </div>
    </div>

    <template #footer>
      <Button :label="t('CONFIRM')" @click="handleOk"/>
    </template>
  </Dialog>
</template>

<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, ref, toRefs} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import eventBus from "@/util/eventBus";
import addBlogForm from "@/views/components/forms/AddBlogForm.vue";
import {useToast} from "@/util/toastUtils";

const axios = injectAxios();
const {t} = useI18n();
const toast = useToast();
const blogFormRef = ref(null);
const props = defineProps(["existingLanguages", "groupId"]);
const {existingLanguages, groupId} = toRefs(props);
const emits = defineEmits(["added-blog"]);
const visible = ref(false);

onMounted(() => {
  eventBus.$on("show-blog-creation-modal", showModal);
});

onBeforeUnmount(() => {
  eventBus.$off("show-blog-creation-modal", showModal);
});

async function showModal() {
  await nextTick();
  visible.value = true;
}

function hideModal() {
  visible.value = false;
}

function handleOk() {
  blogFormRef.value?.submitForm();
}

async function createBlog(blog) {
  if (groupId.value) {
    blog.groupId = groupId.value;
  }

  const resp = await axios.post("/client/blog", blog);
  toast.makeSuccessToast(t("ADDED_BLOG"));
  emits("added-blog", resp.data);
  hideModal();
}

const getAvailableLanguages = computed(() => existingLanguages.value ?? []);
</script>
